const currentDomain = window.location.hostname
const isLocalhost = currentDomain === 'localhost' || currentDomain === '127.0.0.1'

let domain = currentDomain
if (isLocalhost) {
	domain = 'localhost'
} else if (currentDomain.endsWith('hssoft.com')) {
	domain = '.hssoft.com'
}

const amplifyConfig = {
	Auth: {
		Cognito: {
			identityPoolId: import.meta.env.VITE_IDENTITYPOOL_ID,
			userPoolId: import.meta.env.VITE_USERPOOL_ID,
			userPoolClientId: import.meta.env.VITE_USERPOOL_CLIENTID
		}
	}
}

/* token storage is applied separately in v6 (cognitoUserPoolsTokenProvider.setKeyValueStorage) */
export const cookieStorageOptions = {
	domain,
	path: '/',
	expires: 365,
	secure: !isLocalhost,
	sameSite: 'lax'
}

export default amplifyConfig
